function optOut() {
	var form = $("#opt-out-form");
	if (form.length > 0) {
		var input = $("#contactNumber"),
			submitBtn = $("#send-opt-out-button"),
			init = $("#step-init"),
			success = $("#step-success"),
			error = $("#number-not-valid"),
			errorMessage = $("#optout_errorMessage"),
			internalError = $("#optout_internalError"),
			optoutInfo = $("#optout_info");
		var parameters = getUrlParameters();

		if (!parameters.token) {
			errorMessage.removeClass("hidden");
			return;
		}
		$("#token").val(parameters.token);

		validateToken();

		function validateToken() {
			var formData = "token=" + parameters.token;
			$.ajax({
				url: apiPath + "optOut",
				type: "GET",
				data: formData,
				success: function (data) {
					$("#sender-name").html(data.from);
					$("#used-by").html(data.companyName);
					showOptoutInfo();
				},
				error: function () {
					showErrorMessage();
				}
			});
		}

		function formIsCorrect() {
			return input.hasClass("correct");
		}

		function stepSuccess() {
			init.addClass("hidden");
			error.addClass("hidden");
			success.removeClass("hidden");
		}
		function stepError() {
			success.addClass("hidden");
			error.removeClass("hidden");
		}

		function showErrorMessage() {
			optoutInfo.addClass("hidden");
			internalError.addClass("hidden");
			errorMessage.removeClass("hidden");
		}

		function showInternalError() {
			optoutInfo.addClass("hidden");
			internalError.removeClass("hidden");
			errorMessage.addClass("hidden");
		}

		function showOptoutInfo() {
			optoutInfo.removeClass("hidden");
			internalError.addClass("hidden");
			errorMessage.addClass("hidden");
		}

		submitBtn.on("click", function (e) {
			e.preventDefault();
			if (formIsCorrect()) {
				 if (!isStageEnv) {
				sendOptOut(e);
				 }
			}
		});

		form.on("submit", function (e) {
			e.preventDefault();
			if (formIsCorrect()) {
				var formData = form.serialize();
				$.post(apiPath + "optOut", formData)
					.done(function (data) {
						data.optOut ? stepSuccess() : stepError();
					})
					.fail(function () {
						alert("Connection problem");
					});
			}
			return false;
		});
	}
}
